
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'FileInfo',
  props: {
    file: {
      type: Object,
      default: () => { },
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  emits: ['update'],
  methods: {
    onClick () {
      this.$emit('update', this.index)
    },
  },
})
